import { presets } from './create-presets'

import {
  useControls,
} from "leva";

export function PresetsWrapper() {

    const presetsPanel = useControls({ presetsObj: presets()})
    return (
    <pre>
    </pre>
  )
}